'use client';

import { Button } from '@picsart/design-system/components/Button';
import { IllustrationNoResultFound } from '@picsart/design-system/foundation/illustrations/IllustrationNoResultFound';

import { SEARCH_TEST_IDS } from '@/constants/searchConstants/testIds';
import useStyles from './styles';
import type { SearchEmptyProps } from './types';

/**
 * No-results / error state: an illustration plus a two-line explanation, rather
 * than a bare line of text.
 *
 * `isCompact` drops the illustration for the header popover, where it would
 * dwarf what's left.
 */
const SearchEmpty = ({ title, description, isCompact, onRetry }: SearchEmptyProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root} data-testid={SEARCH_TEST_IDS.SUGGESTIONS_EMPTY}>
      {!isCompact && <IllustrationNoResultFound className={classes.illustration} />}
      <span className={classes.title}>{title}</span>
      {description && <span className={classes.description}>{description}</span>}
      {onRetry && (
        <Button variant="outlined" skin="primary" size="small" className={classes.retryButton} onClick={onRetry} dataTestId="search-empty-retry">
          Retry
        </Button>
      )}
    </div>
  );
};

export default SearchEmpty;
